import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ueberliquiditaet-transaktion"
export default class extends Controller {
	static targets = ["sectionAufteilung"]
	connect() {}

	// Bei update des Vermögenswerts muss Aufteilung auf- oder zugeklappt werden
	update({ currentTarget }) {
		const vermoegenswertType = currentTarget.selectedOptions[0].dataset.type

		if (vermoegenswertType == "Depot") {
			this.sectionAufteilungTarget.classList.remove("hidden")
		} else {
			this.sectionAufteilungTarget.classList.add("hidden")
		}
	}
}
